<div *ngIf="showCreateLocationSet">
    <h2 style="margin: 5px 0 10px 0;">Create a New LocationSet</h2>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <table cellspacing="2" class="attribute-full-width">
            <tr>
                <td>
                    <mat-form-field>
                        <input
                            [attr.data-testid]="'locationset_name_text'"
                            matInput
                            required
                            placeholder="LocationSet Name"
                            formControlName="name"
                            [pattern]="spaceValidatorPattern"
                        >
                        <mat-error *ngIf="form.controls['name'].invalid">Please enter a Name</mat-error>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field>
                        <input
                            [attr.data-testid]="'locationset_tag_text'"
                            formControlName="tag"
                            matInput
                            pattern="^[A-Z_0-9]*$"
                            placeholder="LocationSet Tag"
                            required
                            (focusout)="findTagExists()"
                        >
                        <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                            Please enter a Standard Tag
                        </mat-error>
                        <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                            Please enter a Valid Standard Tag
                        </mat-error>
                        <mat-error *ngIf="form.controls['tag'].errors?.tagExists && form.controls['tag'].touched">
                            Tag already exists! Create a new one.
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select
                            [attr.data-testid]="'locationset_type_select'"
                            formControlName="locationSetType"
                            placeholder="Location Set Type"
                            required
                        >
                            <mat-option
                                *ngFor="let locationSetType of locationSetTypes"
                                [attr.data-testid]="locationSetType.name + '_option'"
                                [value]="locationSetType.tag"
                            >{{ locationSetType.name }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.controls['locationSetType'].invalid">
                            Please enter a Value
                        </mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="locationSetTypes.length === 0">
                        No valid location set types
                    </mat-error>
                </td>
                <td>
                    <mat-form-field>
                        <textarea
                            #message
                            [attr.data-testid]="'description_textarea'"
                            formControlName="description"
                            matInput
                            maxlength="256"
                            placeholder="Description"
                        ></textarea>
                        <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select
                            [attr.data-testid]="'country_select'"
                            formControlName="countryCode"
                            placeholder="Country"
                            required
                        >
                            <mat-option
                                *ngFor="let country of countryCodes"
                                [attr.data-testid]="country + '_option'"
                                [value]="country"
                            >
                                {{ country }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                [attr.data-testid]="'cancel_button'"
                class="button-color"
                mat-raised-button
                matTooltip="Cancel creating LocationSet"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
            >Cancel</button>
            <button
                [attr.data-testid]="'save_button'"
                class="button-color"
                [disabled]="isReadOnly$ | async"
                mat-raised-button
                matTooltip="Submit LocationSet"
                type="submit"
            >Save</button>
        </div>
    </form>
</div>
